import script from "./MoreService.vue?vue&type=script&setup=true&lang=js"
export * from "./MoreService.vue?vue&type=script&setup=true&lang=js"

import "./MoreService.vue?vue&type=style&index=0&id=41ad0e40&scoped=true&lang=stylus"

import exportComponent from "C:\\D\\workspace\\idea\\tkt-web\\camee-sport-pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41ad0e40"]])

export default __exports__